import { g as e } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { c as a } from "./createBox-58X037dC.mjs";
import { C as o } from "./generateUtilityClass-DMFG5-Cu.mjs";
const s = e("MuiBox", ["root"]), l = a({
  defaultClassName: s.root,
  generateClassName: o.generate
});
export {
  l as B
};
//# sourceMappingURL=Box-BghdyyLI.mjs.map
